import { collapseToolbox, expandToolbox } from '../../actions';
import { mutator } from 'satcheljs';
import getStore from '../store';

mutator(expandToolbox, setShowExpandedToolbox.bind(null, true));
mutator(collapseToolbox, setShowExpandedToolbox.bind(null, false));

function setShowExpandedToolbox(value: boolean) {
    getStore().showExpandedToolbox = value;
}
